var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconUndo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M7 19v-2h7.1c1.05 0 1.963-.333 2.737-1 .776-.667 1.163-1.5 1.163-2.5s-.387-1.833-1.163-2.5c-.774-.667-1.687-1-2.737-1H7.8l2.6 2.6L9 14 4 9l5-5 1.4 1.4L7.8 8h6.3c1.617 0 3.004.525 4.162 1.575C19.421 10.625 20 11.933 20 13.5c0 1.567-.58 2.875-1.738 3.925C17.104 18.475 15.717 19 14.1 19H7z"
}))));
export default SvgIconUndo;